import { com } from '@eidu/web'
import { kindDefinitions, type KnownKindKey, type SidebarGroup } from '../../domain/kindRegistry'
import { groupEntityTypesByKind } from '../../util/entityKindGroup'
import EntityType = com.eidu.sharedlib.entity.type.EntityType

export type SidebarSection<TItem> = {
  id: string
  title: string
  sidebarGroup: SidebarGroup
  items: TItem[]
}

export const buildSidebarSectionsFromEntityTypes = <TItem>(
  entityTypes: readonly EntityType[],
  createItem: (entityType: EntityType) => TItem
): SidebarSection<TItem>[] =>
  groupEntityTypesByKind(entityTypes, (t) => t).flatMap(({ kindKey, label, entries }) => {
    const def = kindDefinitions[kindKey as KnownKindKey] as
      | { sidebarGroup: SidebarGroup; sidebarSectionId: string }
      | undefined
    if (!def) return []
    return [
      {
        id: def.sidebarSectionId,
        title: label,
        sidebarGroup: def.sidebarGroup,
        items: entries.map((entityType) => createItem(entityType)),
      },
    ]
  })
